import { PreviewCart } from "@app/scripts/components/cart/preview-cart";
import { debounce } from "@app/scripts/utils/debounce";

class PreviewCartClose extends PreviewCart {
    constructor() {
        super();
        
        this.bindEvents();
    }

    bindEvents() {
        this.addEventListener('click', this.closePreviewCart.bind(this));
    }
}

class PreviewCartRemove extends PreviewCart {
    constructor() {
        super();

        this.bindEvents();
    }

    bindEvents() {
        this.addEventListener("click", () => {
            const itemKey = this.getAttribute("data-item-key") as string;
            super.removeItem(itemKey);
        })
    }
}

class PreviewCartUpdate extends PreviewCart {
    private debounceWait: number;
    private changeEvent: Event;
    private inputElement: HTMLInputElement | null;
    private oldQuantity: number;

    constructor() {
        super();
        this.debounceWait = 200;
        this.changeEvent = new Event('change', { bubbles: true });
        this.inputElement = this.querySelector('input');
        this.oldQuantity = Number(this.inputElement?.value);
        this.bindEvents();
    }

    bindEvents() {
        const minusButton = this.querySelector('.minus');
        const plusButton = this.querySelector('.plus');
     
        minusButton?.addEventListener('click', this.onMinusButtonClick.bind(this));
        plusButton?.addEventListener('click', this.onPlusButtonClick.bind(this));

        this.inputElement?.addEventListener('change', debounce((event: Event) => {
            this.onInputChange();
        }, this.debounceWait))
    }

    onMinusButtonClick(event: Event) {
        const previousValue = this.inputElement?.value;
        this.inputElement?.stepDown();

        if(previousValue != this.inputElement?.value) {
            this.inputElement?.dispatchEvent(this.changeEvent);
        }
    }

    onPlusButtonClick(event: Event) {
        this.inputElement?.stepUp();
        this.inputElement?.dispatchEvent(this.changeEvent);
    }

    onInputChange() {
        const newQuantity = Number(this.inputElement?.value) as number;
        const itemKey = this.getAttribute("data-item-key") as string;
        super.updateItem(itemKey, newQuantity, this.oldQuantity);
    }
}


customElements.define("preview-cart-close", PreviewCartClose);
customElements.define("preview-cart-remove", PreviewCartRemove);
customElements.define("preview-cart-qty", PreviewCartUpdate);

